import { useState } from 'react';
import classNames from 'classnames';
import Icon from '@ui/components/Icon/Icon';

import './LabelsColorsGrid.scss';
import { LABEL_COLORS, DEFAULT_LABEL_COLOR, type LabelColor } from '../../../../../types/labelColor';

interface LabelsColorsGridProps {
	initialColor?: { baseColor: string, hoverColor: string };
	onColorClick?: ( color: LabelColor ) => void;
	asRow?: boolean;
}

const LabelsColorsGrid = ( { initialColor, onColorClick, asRow } : LabelsColorsGridProps ) => {
	const [
		selectedColor, setSelectedColor
	] = useState<LabelColor | null>(
		LABEL_COLORS.find( color => (
			color.baseColor === initialColor?.baseColor
				&& color.hoverColor === initialColor?.hoverColor ) )
		|| DEFAULT_LABEL_COLOR
	);

	const isSelected = ( color: string ) => selectedColor?.name === color;

	const handleColorClick = ( color: LabelColor ) => {
		setSelectedColor( color );
		if ( onColorClick ) onColorClick( color );
	}

	const renderColor = (
		{ name, baseColor, hoverColor, cssVar }: LabelColor
	) => {
		const labelColor = { name, baseColor, hoverColor, cssVar };
		const res = isSelected( name )
			? (
				<div
					key={name}
					className="color selected"
					style={{ backgroundColor: cssVar, borderColor: cssVar }}
					onClick={() => handleColorClick( labelColor )}
				>
					<Icon icon="check" size={16} color="black" />
				</div>
			)
			: (
				<div
					key={name}
					className="color"
					style={{ backgroundColor: cssVar }}
					onClick={() => handleColorClick( labelColor )}
				/>
			);
		return res;
	}

	return (
		<div className={classNames( 'LabelsColorsGrid', { asRow } )} data-testid="labels-colors-grid">
			{LABEL_COLORS.map( color => renderColor( color ) )}
		</div>
	);
}

export default LabelsColorsGrid;
